import PlusIcon from '@/assets/icons/plus.svg?react'
import css from './defaultTreeGroup.module.css'
import { ReactNode } from 'react'
import DropdownUnderThreeDots from '@/shared/Dropdowns/DropdownUnderThreeDots'
import useDropdownUnderIconCtrl from '@/shared/Dropdowns/hooks/useDropdownUnderIconCtrl.ts'
import ClickableIcon from '@/shared/Common/ClickableIcon'
import DropdownUnderPlusIcon from '@/shared/Dropdowns/DropdownUnderPlusIcon'

interface IProps<T> {
  title: string
  group: T
  // В случае, если передан onCreate будет отображена кнопка создания
  onCreate?: (group: T) => void
  // В случае, если передан underCreateMenuContent будет отображена кнопка создания, по клику на которую открывается переданное меню
  underCreateMenuContent?: ReactNode
  // В случае, если передан threeDotsMenuContent будет отображена кнопка тре точек, по клику на которую открывается переданное меню
  threeDotsMenuContent?: ReactNode
}

const DefaultTreeGroup = <T = any,>(props: IProps<T>) => {
  const threeDotsMenuCtrl = useDropdownUnderIconCtrl()
  const plusIconMenuCtrl = useDropdownUnderIconCtrl()
  const isMenuOpen = threeDotsMenuCtrl.open || plusIconMenuCtrl.open

  return (
    <div
      className="inline-flex-gap flex-space-between"
      data-menu-open={isMenuOpen}
      onContextMenu={(ev) => {
        ev.preventDefault()
        threeDotsMenuCtrl.setOpen(true)
      }}
    >
      <p className="text-nm line-clamp" style={{ color: 'inherit' }}>
        {props.title}
      </p>
      <div className="inline-flex-gap gap4">
        <div className={css.menuWrapper} data-menu-open={isMenuOpen}>
          {props.threeDotsMenuContent && (
            <DropdownUnderThreeDots
              open={threeDotsMenuCtrl.open}
              setOpen={threeDotsMenuCtrl.setOpen}
              ref={threeDotsMenuCtrl.ref}
              position="right"
            >
              {props.threeDotsMenuContent}
            </DropdownUnderThreeDots>
          )}
        </div>
        {props.onCreate && (
          <div className={css.iconWrapper} data-menu-open={isMenuOpen}>
            <ClickableIcon
              icon={PlusIcon}
              size="default"
              onClick={(ev) => {
                ev.preventDefault()
                ev.stopPropagation()

                props.onCreate(props.group)
              }}
            />
          </div>
        )}
        {props.underCreateMenuContent && (
          <div className={css.iconWrapper} data-menu-open={isMenuOpen}>
            <DropdownUnderPlusIcon
              open={plusIconMenuCtrl.open}
              setOpen={plusIconMenuCtrl.setOpen}
              ref={plusIconMenuCtrl.ref}
              position="right"
            >
              {props.underCreateMenuContent}
            </DropdownUnderPlusIcon>
          </div>
        )}
      </div>
    </div>
  )
}

export default DefaultTreeGroup
